import styled from "styled-components";

export const WordsOfMonth = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const SelfReported = styled.div`
  margin-left: 1em;
  font-size: 0.8em;
  font-style: italic;
  color: var(--text-secondary);
`;
